<article
  class="p-2 p-md-4 w-100 ticket_item"
  [style]="isDownloading ? 'width: 2in; height: 11.5in' : ''"
>
  <div
    class="card border-dark shadow-0 mx-auto"
    [style]="
      isDownloading
        ? 'max-width: 340px;'
        : 'max-width: 340px;min-height: 355px;'
    "
  >
    <div
      class="card-header border-bottom-0 text-center p-0 overflow-hidden bg-black d-flex align-items-center justify-content-center"
      style="height: 50px"
    >
      <img
        [src]="ticketsHeader"
        alt="header"
        style="width: 48px; height: 48px"
      />
    </div>
    <div class="card-body h-100 align-content-center">
      <div class="container-fluid p-0 h-100">
        <div class="row align-items-center d-print-block h-100">
          <div class="col-12 h-100 g-0">
            <div
              class="d-block h-100 d-md-grid d-print-grid align-items-center"
            >
              <ul class="list-group h-auto list-group-flush w-100 mb-3">
                <li
                  class="list-group-item"
                  [class]="isDownloading ? 'text-center' : ''"
                >
                  <div
                    [class]="isDownloading ? '' : 'd-flex'"
                    class="w-100 justify-content-between align-items-top"
                  >
                    <div class="small">
                      <small class="m-0 fw-bold small text-uppercase"
                        >Ticket:</small
                      >
                      <h2 class="m-0 fw-bold h3" class="">
                        {{ data?.ticketId }}
                      </h2>
                    </div>
                    <div [class]="isDownloading ? 'text-center' : 'text-end'">
                      <small class="m-0 fw-bold small d-block">Orden</small>
                      <small class="">TIX-{{ data?.orderId }}</small>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div
                    [class]="isDownloading ? 'text-center' : ''"
                    class="w-100 align-items-top"
                  >
                    <small class="m-0 fw-bold small d-block">Nombre</small>
                    <small class="">{{ data?.buyerName }}</small>
                    <br />
                    <small class="">{{ data?.buyerEmail }}</small>
                  </div>
                </li>
                <li
                  [class]="isDownloading ? 'text-center' : ''"
                  class="list-group-item"
                >
                  <div
                    [class]="isDownloading ? 'p-3' : ''"
                    class="w-100 align-items-top"
                  >
                    <small class="m-0 fw-bold d-block">Evento</small>
                    <small [class]="isDownloading ? 'fs-6' : ''">{{
                      data?.eventName
                    }}</small>
                  </div>
                </li>
                <li
                  [class]="isDownloading ? 'text-center' : 'd-flex'"
                  class="list-group-item justify-content-between"
                >
                  <div class="align-items-top">
                    <small class="m-0 fw-bold small d-block">Ubicación</small>
                    <small class="">{{ place }}</small>
                  </div>
                  <div
                    [class]="isDownloading ? 'text-center' : ''"
                    class="align-items-top"
                  >
                    <small class="m-0 fw-bold small d-block">Fecha</small>
                    <small class="">{{
                      date | dateFormat : 'D MMM y  h:mm a'
                    }}</small>
                  </div>
                </li>
                <li
                  [class]="isDownloading ? 'text-center' : 'd-flex'"
                  class="list-group-item justify-content-between w-full"
                >
                  <div class="align-items-top">
                    <small class="m-0 fw-bold small d-block">Ticket</small>
                    <small class="">{{
                      data?.ticketType?.data?.attributes?.name
                    }}</small>
                  </div>
                  <div
                    class="align-items-top"
                    *ngIf="(data?.ticketLabel ?? null) !== null"
                  >
                    <small class="m-0 fw-bold small d-block">Asiento</small>
                    <small class="">{{ data?.ticketLabel }}</small>
                  </div>
                </li>
              </ul>
              <figure
                class="mb-0 mx-auto text-center d-grid rounded content-qr"
                style="
                  max-width: 300px;
                  margin-top: 50px;
                  width: fit-content;
                  border: 10px solid #000;
                "
              >
                <!-- <qrcode
                  [qrdata]="data?.qrSource || qrSource"
                  [width]="isDownloading ? 100 : 200"
                  [errorCorrectionLevel]="'M'"
                  [allowEmptyString]="true"
                ></qrcode> -->
                <app-qr-code
                  [data]="data?.qrSource || qrSource"
                  [size]="isDownloading ? 150 : 200"
                  logoUrl="/assets/img/logo-tix-circle.svg"
                  style="margin-bottom: -10px;"
                >
                </app-qr-code>
                <div class="small mt-2 text-center mx-auto w-auto">
                  <small>{{
                    data?.printingDate | date : 'MMM d, y h:mm a'
                  }}</small>
                </div>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
